export function cleanPayload<T extends Record<string, any> | null | undefined>(input: T): T {
    // Only process objects
    if (!input || typeof input !== 'object') return input;

    const result: Record<string, any> = Array.isArray(input) ? [] : {};

    for (const [key, value] of Object.entries(input)) {

        // Drop null / undefined
        if (value == null) {
            continue;
        }

        // Trim strings and drop empty ones
        if (typeof value === 'string') {
            const trimmed = value.trim();

            if (trimmed !== '') {
                result[key] = trimmed;
            }

            continue;
        }

        // Recursively clean nested objects
        if (typeof value === 'object' && !Array.isArray(value)) {
            const cleaned = cleanPayload(value);

            // Keep only if object still has keys
            if (Object.keys(cleaned).length > 0) {
                result[key] = cleaned;
            }

            continue;
        }

        // Keep arrays, numbers, booleans, etc.
        result[key] = value;
    }

    return result as T;
}